(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = button.dataset.action;

    switch (action) {
      case 'scroll_down':
        const section = button.closest('.shopify-section');
        if (section && section.nextElementSibling) {
          section.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
        }
        break;

      case 'scroll_to_top':
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
